const UpdateReceivedEvent = {
  CURRENT_SCHEMAGRAPH: 'currentSchemagraphDataUpdateReceived',
  CURRENT_SYSTEM_DATA: 'currentSystemDataUpdateReceived',
  FEEDREADER: 'feedreaderUpdateReceived',
  GENERIC: 'UpdateReceived',
  SYSTEM_MONITORING: 'anlageueberwachungenUpdateReceived',
  SYSLOG: 'syslogUpdateReceived',
};

export default UpdateReceivedEvent;
